import { OpenPluginType, PluginEnum } from '@meitu/saas-editor-core/es/version-types';
import { events, MORE_COLLAPSE_EVENT } from '@/events-bus';
import { editor } from '@/instance';
import { useEditorModel } from '@/store/models/editor-model';
import { usePluginModel } from '@/store/models/plugin-model';

/** 进入ai生图的入口来源  */
export const AI_GENERATE_IMAGE_tracerEntrances = new Set();
export const AI_GENERATE_IMAGE_currentEntranceRef: { value: string | null } = { value: null };
export const AI_GENERATE_IMAGE_enter = (entrance: string) => {
    AI_GENERATE_IMAGE_tracerEntrances.add(entrance);
    AI_GENERATE_IMAGE_currentEntranceRef.value = entrance;
};

const useOpenPlugins = () => {
    const setIsAiExpendImage = usePluginModel((actions) => actions.setIsAiExpendImage);
    const setIsAiModifyImage = usePluginModel((actions) => actions.setIsAiModifyImage);
    const setIsAiGenerateImage = usePluginModel((actions) => actions.setIsAiGenerateImage);
    const setUrlOfAiGenerateImage = usePluginModel((actions) => actions.setExtDataOfAiGenerateImage);
    const setIsShowCollapse = useEditorModel((actions) => actions.setIsShowCollapse);

    return {
        openPlugin: ({ func, entrance, hasTrackFunc, extData }: OpenPluginType) => {
            if (func === PluginEnum.AI_EXPEND_IMAGE) {
                setIsAiExpendImage(true);
                editor.services.mask.show({
                    background: true,
                });
            } else if (func === PluginEnum.AI_MODIFY_IMAGE) {
                setIsAiModifyImage(true);
                editor.services.mask.show({
                    background: true,
                });
            } else if (func === PluginEnum.AI_GENERATE_IMAGE) {
                setIsAiGenerateImage(true);
                setUrlOfAiGenerateImage(extData ?? null);
                editor.services.mask.show({
                    background: true,
                });
            }
            setIsShowCollapse(true);
            events.emit(MORE_COLLAPSE_EVENT, { func, entrance });
            hasTrackFunc &&
                window._stat_track?.('hbsj_subfunction_click', {
                    first_func: 'home_tools',
                    second_func: func,
                });
        },
    };
};

export default useOpenPlugins;
